import { useI18n } from '@cascade/react/i18n';
import { useAuthentication } from '@cascade/react/authentication';
import { Button } from '@cascade/ui-library';
import classes from './Header.module.scss';
import { Logo } from '#components/logo/index.ts';

export const Header = () => {
  const { translate } = useI18n();
  const { isAuthenticated, signOut } = useAuthentication();

  return (
    <header className={classes.header}>
      <Logo />
      {isAuthenticated ? (
        <Button
          variant='secondary'
          ghost
          label={translate('session.signOut')}
          className={classes.action}
          onClick={signOut}
        />
      ) : null}
    </header>
  );
};
